import * as _ from "lodash"

// A selector which returns true is some of the given actions are still fetching, or false otherwise
export const createLoadingSelector = actions => state => {
  return _(actions).some(action => _.get(state, `fetching.fetching_${action}`))
}

// A selector which returns a comma separated list of errors found for the given actions
export const createErrorSelector = actions => state => {
  return _(actions)
    .map(action => [
      action.toUpperCase(),
      _.get(state, `fetching.error_${action}`)
    ])
    .filter(([_, msg]) => msg)
    .map(([action, msg]) => `[${action}] ${msg}`)
    .join(", ")
}
